import React from "react";
import Link from "next/link";
import Item from "../Items/churchPageEventItem";
import GridItemSmallScreens from "../Items/SmallScreenItems/gridItemSmallScreens";
import Arrow from "../Icons/Arrow";

const List = ({ itemNb, events, header, link, isUpcoming = false }) => {
  return (
    <div className="flex flex-col w-full max-w-churchPage">
      <div className="flex justify-between pt-1 w-full">
        <h2 className="font-bold text-2xl my-5">{header}</h2>
        <div className="tablet:hidden">
          <Link href={link}>
            <a
              role="button"
              type="button"
              className="flex items-center text-gray text-bodyText appearance-none tablet-100:text-[17px]"
            >
              <span className="pr-2.5"> Katso kaikki </span>
              <Arrow color={"#7D7D7D"}></Arrow>
            </a>
          </Link>
        </div>
      </div>
      <ul className="flex w-full flex-wrap items-start">
        {events &&
          events.map((item, index) => {
            if (index < itemNb)
              return (
                <React.Fragment key={item?._id}>
                  <div className="tablet:hidden mr-2 max-w-xxxs w-full">
                    <Item key={index} item={item} />
                  </div>
                  <div className="hidden tablet:block mr-4 mb-4 tablet:max-w-[266px] w-full">
                    <GridItemSmallScreens item={item} isUpcoming={isUpcoming} />
                  </div>
                </React.Fragment>
              );
          })}
      </ul>
      <div className="hidden justify-center tablet:flex">
        <Link href={link}>
          <a
            role="button"
            type="button"
            className="flex items-center text-gray text-bodyText appearance-none tablet-100:text-[17px]"
          >
            <span className="pr-2.5">Katso kaikki</span>
            <Arrow color={"#7D7D7D"}></Arrow>
          </a>
        </Link>
      </div>
    </div>
  );
};

export default List;
